import { useSelector } from 'react-redux';
import { selectUser, useCloneEntity } from 'gossamer-front-end';
import { EventProfile, EventProfileRow } from 'cb-model';
import { CustomInfo } from 'cb-unified';
import { ReferenceField } from 'gossamer-unified';

export const useLocalEventProfile = () => {
  const LocalEventProfile = useCloneEntity(EventProfile);
  const override: Partial<EventProfileRow> = {
    status: 'ACTIVE',
  };
  const user = useSelector(selectUser);
  (LocalEventProfile.fields.feedback_form_id as ReferenceField).refFilters = [
    {
      fieldId: 'institution_id',
      operator: 'eq',
      value: (user?.customInfo as CustomInfo | undefined)?.adminInstitutionId ?? null,
      display: 'hidden',
    },
  ];
  if ((user.customInfo as CustomInfo).adminInstitutionId) {
    override.institution_id = (user.customInfo as CustomInfo).adminInstitutionId;
  }
  return { LocalEventProfile, override };
};
